// extracted by mini-css-extract-plugin
export default {"spinner-content":"ClaimDepartment_spinner-content__Ap21+","spinner":"ClaimDepartment_spinner__-5k2y"};